import styles from './loading.module.scss';
const SKELETON_CHIPS = 6;
const SKELETON_LIST_CARDS = 6; // compact rows in the split view
const SKELETON_GRID_CARDS = 9; // fallback grid count for narrower viewports

export default function Loading() {
  return <div className={styles.page} role="status" aria-live="polite" aria-label="Loading workspaces" data-sentry-component="Loading" data-sentry-source-file="loading.tsx">
            {/* Filter-chips row — mirrors ExploreFilterChips */}
            <div className={styles.chipsRow} aria-hidden="true">
                <div className={styles.chipsInner}>
                    <span className={`${styles.shimmer} ${styles.chipFilters}`} />
                    {Array.from({
          length: SKELETON_CHIPS
        }).map((_, i) => <span key={i} className={`${styles.shimmer} ${styles.chip}`} />)}
                </div>
            </div>

            {/* Search bar — mirrors ExploreToolbar (fixed into the header on
                desktop, in flow below the chips on mobile). */}
            <div className={styles.toolbar} aria-hidden="true">
                <div className={`${styles.shimmer} ${styles.searchBar}`} />
            </div>

            {/* Results row — mirrors ExploreToolbar resultsRow */}
            <div className={styles.resultsRow} aria-hidden="true">
                <div className={styles.resultsRowInner}>
                    <span className={`${styles.shimmer} ${styles.headingLine}`} />
                    <div className={styles.viewToggle}>
                        <span className={`${styles.shimmer} ${styles.viewLabel}`} />
                        <div className={styles.viewToggleGroup}>
                            <span className={`${styles.shimmer} ${styles.pillToggle}`} />
                            <span className={`${styles.shimmer} ${styles.pillToggle}`} />
                            <span className={`${styles.shimmer} ${styles.pillToggle}`} />
                        </div>
                    </div>
                </div>
            </div>

            {/* Desktop default: split view — two vertical cards per row beside
                the sticky map. Mirrors ExploreSplit. */}
            <div className={styles.splitWrap} aria-hidden="true">
                <div className={styles.listCol}>
                    {Array.from({
          length: SKELETON_LIST_CARDS
        }).map((_, i) => <div key={i} className={styles.card}>
                            <div className={`${styles.shimmer} ${styles.cardImage}`} />
                            <span className={`${styles.shimmer} ${styles.lineTitle}`} />
                            <span className={`${styles.shimmer} ${styles.lineCity}`} />
                            <span className={`${styles.shimmer} ${styles.linePrice}`} />
                        </div>)}
                </div>
                <div className={styles.mapCol}>
                    <div className={`${styles.shimmer} ${styles.mapSticky}`} />
                </div>
            </div>

            {/* <1024px / grid view — mirrors the new ExploreGrid card. */}
            <div className={styles.gridWrap} aria-hidden="true">
                <div className={styles.grid}>
                    {Array.from({
          length: SKELETON_GRID_CARDS
        }).map((_, idx) => <div key={idx} className={styles.card}>
                            <div className={`${styles.shimmer} ${styles.cardImage}`} />
                            <span className={`${styles.shimmer} ${styles.lineTitle}`} />
                            <span className={`${styles.shimmer} ${styles.lineCity}`} />
                            <span className={`${styles.shimmer} ${styles.linePrice}`} />
                        </div>)}
                </div>
            </div>
        </div>;
}